module.exports = __webpack_public_path__ + "static/media/muna_aunt_eye_blink.51b18998.png";